export const data3_2_1 = [{
    name: 'BAR',
    sort: 0,
    budget_r_nts: 0,
    budget_nts_mix: 0,
    budget_arr: 0,
    budget_rev: 0,
    budget_rev_mix: 0,
    sum_r_nts: 0,
    sum_nts_mix: 0,
    sum_arr: 0,
    sum_rev: 0,
    sum_rev_mix: 0,
    diff_r_nts: 0,
    diff_nts_mix: 0,
    diff_arr: 0,
    diff_arr_mix: 0,
    diff_rev: 0,
    diff_rev_mix: 0,
}, {
    name: 'Corp Negotiated',
    sort: 1,
    budget_r_nts: 0,
    budget_nts_mix: 0,
    budget_arr: 0,
    budget_rev: 0,
    budget_rev_mix: 0,
    sum_r_nts: 0,
    sum_nts_mix: 0,
    sum_arr: 0,
    sum_rev: 0,
    sum_rev_mix: 0,
    diff_r_nts: 0,
    diff_nts_mix: 0,
    diff_arr: 0,
    diff_arr_mix: 0,
    diff_rev: 0,
    diff_rev_mix: 0,
}, {
    name: 'Government',
    sort: 2,
    budget_r_nts: 0,
    budget_nts_mix: 0,
    budget_arr: 0,
    budget_rev: 0,
    budget_rev_mix: 0,
    sum_r_nts: 0,
    sum_nts_mix: 0,
    sum_arr: 0,
    sum_rev: 0,
    sum_rev_mix: 0,
    diff_r_nts: 0,
    diff_nts_mix: 0,
    diff_arr: 0,
    diff_arr_mix: 0,
    diff_rev: 0,
    diff_rev_mix: 0,
}, {
    name: 'Packages',
    sort: 3,
    budget_r_nts: 0,
    budget_nts_mix: 0,
    budget_arr: 0,
    budget_rev: 0,
    budget_rev_mix: 0,
    sum_r_nts: 0,
    sum_nts_mix: 0,
    sum_arr: 0,
    sum_rev: 0,
    sum_rev_mix: 0,
    diff_r_nts: 0,
    diff_nts_mix: 0,
    diff_arr: 0,
    diff_arr_mix: 0,
    diff_rev: 0,
    diff_rev_mix: 0,
}, {
    name: 'Wholesale',
    sort: 4,
    budget_r_nts: 0,
    budget_nts_mix: 0,
    budget_arr: 0,
    budget_rev: 0,
    budget_rev_mix: 0,
    sum_r_nts: 0,
    sum_nts_mix: 0,
    sum_arr: 0,
    sum_rev: 0,
    sum_rev_mix: 0,
    diff_r_nts: 0,
    diff_nts_mix: 0,
    diff_arr: 0,
    diff_arr_mix: 0,
    diff_rev: 0,
    diff_rev_mix: 0,
}, {
    name: 'E-Commerce',
    sort: 5,
    budget_r_nts: 0,
    budget_nts_mix: 0,
    budget_arr: 0,
    budget_rev: 0,
    budget_rev_mix: 0,
    sum_r_nts: 0,
    sum_nts_mix: 0,
    sum_arr: 0,
    sum_rev: 0,
    sum_rev_mix: 0,
    diff_r_nts: 0,
    diff_nts_mix: 0,
    diff_arr: 0,
    diff_arr_mix: 0,
    diff_rev: 0,
    diff_rev_mix: 0,
}, {
    name: 'Discounts',
    sort: 6,
    budget_r_nts: 0,
    budget_nts_mix: 0,
    budget_arr: 0,
    budget_rev: 0,
    budget_rev_mix: 0,
    sum_r_nts: 0,
    sum_nts_mix: 0,
    sum_arr: 0,
    sum_rev: 0,
    sum_rev_mix: 0,
    diff_r_nts: 0,
    diff_nts_mix: 0,
    diff_arr: 0,
    diff_arr_mix: 0,
    diff_rev: 0,
    diff_rev_mix: 0,
}, {
    name: 'TTL TRANSIENT',
    sort: 7,
    budget_r_nts: 0,
    budget_nts_mix: 0,
    budget_arr: 0,
    budget_rev: 0,
    budget_rev_mix: 0,
    sum_r_nts: 0,
    sum_nts_mix: 0,
    sum_arr: 0,
    sum_rev: 0,
    sum_rev_mix: 0,
    diff_r_nts: 0,
    diff_nts_mix: 0,
    diff_arr: 0,
    diff_arr_mix: 0,
    diff_rev: 0,
    diff_rev_mix: 0,
}, {
    name: 'Group Business',
    sort: 8,
    budget_r_nts: 0,
    budget_nts_mix: 0,
    budget_arr: 0,
    budget_rev: 0,
    budget_rev_mix: 0,
    sum_r_nts: 0,
    sum_nts_mix: 0,
    sum_arr: 0,
    sum_rev: 0,
    sum_rev_mix: 0,
    diff_r_nts: 0,
    diff_nts_mix: 0,
    diff_arr: 0,
    diff_arr_mix: 0,
    diff_rev: 0,
    diff_rev_mix: 0,
}, {
    name: 'Group Leisure',
    sort: 9,
    budget_r_nts: 0,
    budget_nts_mix: 0,
    budget_arr: 0,
    budget_rev: 0,
    budget_rev_mix: 0,
    sum_r_nts: 0,
    sum_nts_mix: 0,
    sum_arr: 0,
    sum_rev: 0,
    sum_rev_mix: 0,
    diff_r_nts: 0,
    diff_nts_mix: 0,
    diff_arr: 0,
    diff_arr_mix: 0,
    diff_rev: 0,
    diff_rev_mix: 0,
}, {
    name: 'TTL GROUP',
    sort: 10,
    budget_r_nts: 0,
    budget_nts_mix: 0,
    budget_arr: 0,
    budget_rev: 0,
    budget_rev_mix: 0,
    sum_r_nts: 0,
    sum_nts_mix: 0,
    sum_arr: 0,
    sum_rev: 0,
    sum_rev_mix: 0,
    diff_r_nts: 0,
    diff_nts_mix: 0,
    diff_arr: 0,
    diff_arr_mix: 0,
    diff_rev: 0,
    diff_rev_mix: 0,
}, {
    name: 'CONTRACT',
    sort: 11,
    budget_r_nts: 0,
    budget_nts_mix: 0,
    budget_arr: 0,
    budget_rev: 0,
    budget_rev_mix: 0,
    sum_r_nts: 0,
    sum_nts_mix: 0,
    sum_arr: 0,
    sum_rev: 0,
    sum_rev_mix: 0,
    diff_r_nts: 0,
    diff_nts_mix: 0,
    diff_arr: 0,
    diff_arr_mix: 0,
    diff_rev: 0,
    diff_rev_mix: 0,
}, {
    name: 'OTHERS',
    sort: 12,
    budget_r_nts: 0,
    budget_nts_mix: 0,
    budget_arr: 0,
    budget_rev: 0,
    budget_rev_mix: 0,
    sum_r_nts: 0,
    sum_nts_mix: 0,
    sum_arr: 0,
    sum_rev: 0,
    sum_rev_mix: 0,
    diff_r_nts: 0,
    diff_nts_mix: 0,
    diff_arr: 0,
    diff_arr_mix: 0,
    diff_rev: 0,
    diff_rev_mix: 0,
}, {
    name: 'GRAND TOTAL',
    sort: 13,
    budget_r_nts: 0,
    budget_nts_mix: 0,
    budget_arr: 0,
    budget_rev: 0,
    budget_rev_mix: 0,
    sum_r_nts: 0,
    sum_nts_mix: 0,
    sum_arr: 0,
    sum_rev: 0,
    sum_rev_mix: 0,
    diff_r_nts: 0,
    diff_nts_mix: 0,
    diff_arr: 0,
    diff_arr_mix: 0,
    diff_rev: 0,
    diff_rev_mix: 0,
}, {
    name: 'Available Rms',
    sort: 14,
    budget_r_nts: 0,
    budget_nts_mix: 0,
    budget_arr: 0,
    budget_rev: 0,
    budget_rev_mix: 0,
    sum_r_nts: 0,
    sum_nts_mix: 0,
    sum_arr: 0,
    sum_rev: 0,
    sum_rev_mix: 0,
    diff_r_nts: 0,
    diff_nts_mix: 0,
    diff_arr: 0,
    diff_arr_mix: 0,
    diff_rev: 0,
    diff_rev_mix: 0,
}, {
    name: 'Occupancy %',
    sort: 15,
    budget_r_nts: 0,
    budget_nts_mix: 0,
    budget_arr: 0,
    budget_rev: 0,
    budget_rev_mix: 0,
    sum_r_nts: 0,
    sum_nts_mix: 0,
    sum_arr: 0,
    sum_rev: 0,
    sum_rev_mix: 0,
    diff_r_nts: 0,
    diff_nts_mix: 0,
    diff_arr: 0,
    diff_arr_mix: 0,
    diff_rev: 0,
    diff_rev_mix: 0,
}, {
    name: 'RevPAR',
    sort: 16,
    budget_r_nts: 0,
    budget_nts_mix: 0,
    budget_arr: 0,
    budget_rev: 0,
    budget_rev_mix: 0,
    sum_r_nts: 0,
    sum_nts_mix: 0,
    sum_arr: 0,
    sum_rev: 0,
    sum_rev_mix: 0,
    diff_r_nts: 0,
    diff_nts_mix: 0,
    diff_arr: 0,
    diff_arr_mix: 0,
    diff_rev: 0,
    diff_rev_mix: 0,
}];



// WEBPACK FOOTER //
// ./src/components/table/4.0/4-2/data.js